import Card from "@mui/material/Card";
import CardButton from "../cardButton";
import StarIcon from "@mui/icons-material/Star";
import Button from '@mui/material/Button';

interface props{
  title:any;
  end_date:any;
  Points:any;

}

function ConfirmCard({title,end_date,Points}:props) {
  return (
    <div className="mx-4 w-screen">
      <Card className="p-4 shadow-lg w-full mr-5" sx={{ borderRadius: "10px" }}>
        <div className="flex flex-col space-y-4">
          {/* First Row */}
          <div className="flex text-2xl font-bold">{title}</div>
          {/* Second Row */}
          <div className="flex">
            <div className="flex justify-start items-center flex-1 text-sm">
              {end_date}
            </div>
            <div className="flex flex-1 justify-end items-center">
              <div>
                <Button
                  sx={{ borderRadius: "25px", textTransform: "none",cursor:"default",borderColor: process.env.REACT_APP_PRIMARY_COLOR, 
                   }}
                  startIcon={<StarIcon sx={{ color: process.env.REACT_APP_PRIMARY_COLOR }}/>}
                  variant="outlined"
                >
                  <p style={{color:process.env.REACT_APP_PRIMARY_COLOR}}>
                 {Points}
                 </p>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}

export default ConfirmCard;
